<template>
	<page>
		<module enable-flex>
			<div class="schedule-handle flex-between-center">
				<div class="flex-center-cross">
					<ul class="type flex-center">
						<li v-for="(item, i) in dataSourceOption" :key="i" :class="{'z-crt': dataSource == item.value}" @click="dataSource = item.value">{{item.name}}</li>
					</ul>
					<ul class="type flex-center">
						<li v-for="(item, i) in dateTypeOption" :key="i" :class="{'z-crt': dateType == item.value}" @click="dateType = item.value">{{item.name}}</li>
					</ul>
					<c-tooltip ref="filter" color="white" z-index="2000" click-event>
						<div class="filter flex-center">
							<i class="tf">&#xe60b;</i>
							<span v-show="searchParamsCount" class="flex-center">{{searchParamsCount}}</span>
						</div>
						<template #tip>
							<div class="filter-search" @click="$event => $event.stopPropagation()">
								<m-search ref="search" column="1" :button="false" style="width: 320px; padding: 0;" @search="updateData">
									<m-search-item label="产品信息">
										<c-input name="product_info" placeholder="名字、编号"></c-input>
									</m-search-item>
									<m-search-item label="工单编号">
										<c-input name="work_code" placeholder="请输入"></c-input>
									</m-search-item>
									<m-search-item label="状态">
										<c-select name="states" :options="stateOptions" multiple placeholder="请选择"></c-select>
									</m-search-item>
									<m-search-item v-if="dataSource == 2" label="工序">
										<c-select ref="processFilter" name="process_ids" multiple placeholder="请选择" async @search="searchProcess">
											<template #option="{data, selected}">
												<select-option
													:name="data.name"
													:image="data.data.process_image"
													:selected="selected"
												></select-option>
											</template>
										</c-select>
									</m-search-item>
								</m-search>
								<div class="flex">
									<c-button class="filter-button flex-grow" color="main" @click="filterHandle">查询</c-button>
									<c-button class="filter-button" @click="$refs.search.clear()">重置条件</c-button>
								</div>
							</div>
						</template>
					</c-tooltip>
					<c-refresh class="refresh flex-center" @click="updateData"></c-refresh>
				</div>
				<div class="flex-column flex-center">
					<div class="schedule-date">{{dateText}}</div>
					<ul class="legend flex">
						<li v-for="(item, i) in stateOptions" :key="i" class="flex-center">
							<div :style="{'background': item.color}"></div>
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
				<div class="flex-end-center">
					<ul class="tab flex">
						<li v-for="(item, i) in viewList" :key="i" :class="{'z-crt': viewType == item.value}" @click="viewType = item.value">{{item.name}}</li>
					</ul>
					
					<ul class="tab flex">
						<li @click="switchHandle(-1)"><i class="tf tf-angle-left"></i></li>
						<li @click="switchHandle()">回到今天</li>
						<li @click="switchHandle(1)"><i class="tf tf-angle-right"></i></li>
					</ul>
				</div>
			</div>
			
			<div class="flex-grow flex-column schedule-view">
				<div v-if="viewType == 'month'" class="flex-grow-auto flex-column">
					<ul class="week flex">
						<li v-for="(item, i) in weeks" :key="i" class="flex-grow">{{weeksName[i]}}</li>
					</ul>
					
					<c-right-menu class="flex-grow flex-column">
						<div class="flex-grow flex-column">
							<div v-for="(week, i) in dayList" :key="i" class="month-week flex flex-grow" :style="{'min-height': monthMoreIndex == i ? `${monthMoreHeight}px` : '115px'}">
								<div class="month-week-handle" title="查看这一周" @click="quickHandle('week', week[0])" @contextmenu="beforeRightMenuHandle(false)"></div>
								<div v-for="(day, j) in week" :key="j" ref="monthDay" class="schedule-cell month-day flex-grow" @contextmenu="beforeRightMenuHandle(false, day.$day)">
									<div class="month-day-num" :class="{'z-hl': day.today, 'z-unimp': day.otherMonth}" title="查看这一天" @click="quickHandle('day', day)">{{day.$day.getDate()}}</div>
									<ul>
										<template v-for="(item, k) in day.dateList">
											<li v-if="item" :key="k"
												v-show="k < monthMoreLimit || monthMoreIndex == i"
												class="schedule-item flex-center-cross"
												:class="{'z-hl': hoverId == item.data.id || currentItem.id == item.data.id}"
												:title="item.data.content"
												:start="item.start"
												:end="item.after === 0"
												:across="item.after !== undefined"
												:state="item.data.state"
												@click.stop="scheduleHandle({handle: 'detail'}, item.data)"
												@contextmenu="beforeRightMenuHandle(item.data, day.$day)"
												@mouseenter="hoverId = item.data.id"
												@mouseleave="hoverId = false"
											>
												<template v-if="day.$day.getDay() == 0 || item.start">
													<span v-if="dataSource == 2 && item.data.out_sourcing_plan_count > 0" class="icon" style="font-size: 10px; color: #0D6EFE;">委外</span>
													<i v-if="item.data.priority == 1" class="icon tf-urgent" style="color: #f00;"></i>
													<i v-else-if="item.data.priority == 2" class="icon tf-pause" style="color: #333;"></i>
													<p class="ellipsis">{{item.data.content}}</p>
												</template>
											</li>
											<li v-else :key="k" blank></li>
										</template>
									</ul>
									<template v-if="moreCount(day.dateList) > 0">
										<a v-if="monthMoreIndex == i" class="month-day-more" @click.stop="moreHandle(-1)">收起</a>
										<a v-else class="month-day-more" @click.stop="moreHandle(i)">还有{{moreCount(day.dateList)}}项...</a>
									</template>
								</div>
							</div>
						</div>

						<template #menu>
							<c-menu-list>
								<c-menu-group v-for="(group, i) in rightMenu" :key="i">
									<c-menu-item v-for="(item, j) in group" :key="j" @click="rightMenuHandle(item)">{{item.name}}</c-menu-item>
								</c-menu-group>
							</c-menu-list>
						</template>
					</c-right-menu>
				</div>
				
				<div v-else class="flex-grow-auto flex-column">
					<ul class="week flex">
						<li style="width: 50px;"></li>
						<li v-for="(item, i) in weeks" :key="i" class="flex-grow flex-center-cross">
							<template v-if="dayList[i]">
								<p>{{weeksName[dayList[i].$day.getDay()]}}</p>
								<a :class="{'z-hl': dayList[i].today}" title="查看这一天" @click="quickHandle('day', dayList[i])">{{dayList[i].$day.getDate()}}</a>
							</template>
						</li>
					</ul>
					
					<c-right-menu class="flex-grow-auto flex-column">
						<div class="flex-grow-auto flex-column">
							<div v-show="fllday" class="flex">
								<div class="week-fullday">
									<div class="text">全天</div>
								</div>
								<div v-for="(day, i) in dayList" :key="i" class="week-fullday month-day flex-grow flex-column">
									<div class="schedule-cell flex-grow-auto" @contextmenu="beforeRightMenuHandle(false, day.$day)">
										<ul>
											<template v-for="(item, k) in day.dateList">
												<li v-if="item" :key="k"
													class="schedule-item flex-center-cross"
													:class="{'z-hl': hoverId == item.data.id || currentItem.id == item.data.id}"
													:title="item.data.content"
													:start="item.start"
													:end="item.after === 0"
													:across="item.after !== undefined"
													:state="item.data.state"
													@click.stop="scheduleHandle({handle: 'detail'}, item.data)"
													@contextmenu="beforeRightMenuHandle(item.data, day.$day)"
													@mouseenter="hoverId = item.data.id"
													@mouseleave="hoverId = false"
												>
													<template v-if="day.$day.getDay() == 0 || item.start">
														<span v-if="dataSource == 2 && item.data.out_sourcing_plan_count > 0" class="icon" style="font-size: 10px; color: #0D6EFE;">委外</span>
														<i v-if="item.data.priority == 1" class="icon tf-urgent" style="color: #f00;"></i>
														<i v-else-if="item.data.priority == 2" class="icon tf-pause"></i>
														<p class="ellipsis">{{item.data.content}}</p>
													</template>
												</li>
												<li v-else :key="k" blank></li>
											</template>
										</ul>
									</div>
								</div>
							</div>
							<div class="flex-grow-auto flex">
								<div class="week-day">
									<div v-for="(hour, j) in hours" :key="j" class="hour-text">{{j < 9 ? '0' : ''}}{{j + 1}}:00</div>
								</div>
								<div v-for="(day, i) in dayList" :key="i" class="week-day flex-grow">
									<div v-for="(hour, j) in hours" :key="j" class="schedule-cell hour" @contextmenu="beforeRightMenuHandle(false, day.$day, j)"></div>
									<div class="week-day-col flex">
										<ul v-for="(col, j) in day.timeList" :key="j" class="flex-grow">
											<li v-for="(item, k) in col" :key="k" :style="{'top': `${item.start * 50}px`, 'bottom': `${item.end * 50}px`, 'width': `${(item.after ? (item.after - j) : (day.timeList.length - j)) * 100}%`}">
												<div class="schedule-item"
													:class="{'z-hl': hoverId == item.data.id || currentItem.id == item.data.id}"
													:title="item.data.content"
													:state="item.data.state"
													@click.stop="scheduleHandle({handle: 'detail'}, item.data)"
													@contextmenu="beforeRightMenuHandle(item.data, day.$day)"
													@mouseenter="hoverId = item.data.id" @mouseleave="hoverId = false"
												>
													<div class="flex-center-cross ellipsis">
														<span v-if="dataSource == 2 && item.data.out_sourcing_plan_count > 0" class="icon" style="font-size: 10px; color: #0D6EFE;">委外</span>
														<i v-if="item.data.priority == 1" class="icon tf-urgent" style="color: #f00;"></i>
														<i v-else-if="item.data.priority == 2" class="icon tf-pause"></i>
														<p class="ellipsis">{{item.data.content}}</p>
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>

						<template #menu>
							<c-menu-list>
								<c-menu-group v-for="(group, i) in rightMenu" :key="i">
									<c-menu-item v-for="(item, j) in group" :key="j" @click="rightMenuHandle(item)">{{item.name}}</c-menu-item>
								</c-menu-group>
							</c-menu-list>
						</template>
					</c-right-menu>
				</div>
			</div>

			<!--创建、编辑工单信息弹窗-->
			<work-edit ref="workEdit" @resolve="updateData"></work-edit>
			<!--编辑任务信息弹窗-->
			<task-edit ref="taskEdit" @resolve="updateData"></task-edit>
		</module>
	</page>
</template>

<script>
	import workEdit from '@/pages/production/work_edit.vue';
	import taskEdit from '@/pages/production/task_edit.vue';

	export default {
		components: {
			workEdit,
			taskEdit
		},

		props: {
			task: String
		},

		data() {
			return {
				date: new Date(),

				dataSourceOption: [{
					name: '工单',
					value: 1
				}, {
					name: '任务',
					value: 2
				}],
				dataSource: this.task ? 2 : 1,
				dateTypeOption: [{
					name: '计划时间',
					value: 1
				}, {
					name: '实际时间',
					value: 2
				}],
				dateType: 1,

				stateOptions: [{
					name: '未开始',
					value: 1,
					color: '#999'
				}, {
					name: '执行中',
					value: 2,
					color: '#0D6EFE'
				}, {
					name: '已结束',
					value: 3,
					color: '#2EBC78'
				}, {
					name: '已取消',
					value: 4,
					color: '#FF5400'
				}],

				viewList: [{
					name: '月',
					value: 'month'
				}, {
					name: '周',
					value: 'week'
				}, {
					name: '日',
					value: 'day'
				}],
				viewType: 'month',
				
				weeksName: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
				dayList: [],
				dateQueue: [],
				timeQueue: [],
				hoverId: false,
				currentItem: false,
				currentDate: false,
				monthMoreLimit: 0,
				monthMoreIndex: -1,
				monthMoreHeight: 0,

				searchParams: {}
			}
		},
		
		computed: {
			dateText() {
				let date = this.date;
				if (this.viewType == 'week') {
					date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + 6 - this.date.getDay());
				}
				return date.format('yyyy年MM月');
			},

			weeks() {
				return new Array(this.viewType != 'day' ? 7 : 1);
			},
			
			fllday() {
				return this.viewType != 'month' && !!this.dayList.find(item => item.dateList.length);
			},
			
			hours() {
				return new Array(24);
			},
			
			rightMenu() {
				return (this.currentDate ? [[{
					name: this.dataSource == 1 ? '新建工单' : '新建任务',
					handle: 'create'
				}]] : []).concat([[{
					name: '刷新',
					handle: 'refresh'
				}]])
			},
			
			viewData() {
				return {
					date: this.date,
					view: this.viewType
				}
			},

			searchParamsCount() {
				return Object.keys(this.searchParams).filter(item => {
					return Array.isArray(this.searchParams[item]) ? this.searchParams[item].length : this.searchParams[item];
				}).length;
			}
		},
		
		watch: {
			dataSource() {
				this.$nextTick(() => {
					this.$refs.search.search();
				});
			},

			dateType() {
				this.updateData();
			},

			viewData(val, old) {
				if (val.date != old.date) {
					this.updateView();
				} else if (val.view != old.view) {
					let date;

					if (['dayweek' ,'weekday'].includes(val.view + old.view)) {
						date = this.dayList[0].$day;
					} else if (old.view == 'month') {
						date = this.dayList[1][0].$day;
						date = new Date(date.getFullYear(), date.getMonth(), 1);
					} else {
						date = this.dayList[this.dayList.length - 1].$day;
					}
					
					this.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
				} else {
					this.updateView();
				}
			}
		},
		
		mounted() {
			this._windowClick = () => {
				this.currentItem = false;
				this.currentDate = false;
				this.$refs.search.set(this.searchParams);
				this.$refs.processFilter && this.$refs.processFilter.setValueData(this._processFilterData);
			}
			window.addEventListener('click', this._windowClick);
			
			this._resize = () => {
				if (this.viewType != 'month') return;
				let height = Math.min(this.$refs.monthDay[0].clientHeight, this.$refs.monthDay[7].clientHeight) - 32 - 24;
				let num = Math.floor(height / 29);
				this.monthMoreLimit = num;
			}
			window.addEventListener('resize', this._resize);
			this.$nextTick(this._resize);
			this.updateView();
		},
		
		beforeDestroy() {
			window.removeEventListener('click', this._windowClick);
			window.removeEventListener('resize', this._resize);
		},
		
		methods: {
			scheduleHandle(menu, data, date) {
				let handle = menu.handle.split(',');
				switch (handle[0]) {
				case 'create':
					if (this.dataSource == 1) {
						this.$refs.workEdit.open(undefined, false, {
							planDate: [date.date.format(`yyyy-MM-dd ${date.time ? this.doubleFmt(date.time) : '00'}:00`), date.date.format('yyyy-MM-dd 23:59')]
						});
					} else {
						this.$refs.taskEdit.open(undefined, {
							planDate: [date.date.format(`yyyy-MM-dd ${date.time ? this.doubleFmt(date.time) : '00'}:00`), date.date.format('yyyy-MM-dd 23:59')]
						});
					}
					break;
				
				case 'detail':
					if (this.dataSource == 1) {
						this.globalDialog('workDetail', {props: {id: data.id}});
					} else {
						this.globalDialog('taskDetail', {props: {id: data.id}})
					}
					break;
					
				case 'refresh':
					this.updateData();
					break;
				}
			},
			
			switchHandle(type) {
				if (!type) {
					this.date = new Date();
				} else {
					switch (this.viewType) {
					case 'month':
						this.date = new Date(this.date.getFullYear(), this.date.getMonth() + type, 1);
						return;
						
					case 'week':
						this.date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + type * 7);
						return;
						
					case 'day':
						this.date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + type);
						return;
					}
				}
			},

			quickHandle(view, day) {
				this.date = new Date(day.$day.getFullYear(), day.$day.getMonth(), day.$day.getDate());
				this.viewType = view;
			},
			
			updateView() {
				let now = new Date(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
				
				if (this.viewType == 'month') {
					let first = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
					let last = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
					
					let before = first.getDay(),
						length = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate() + before + (6 - last.getDay());
					
					let list = [];
					for (let i = 1; i <= length; i++) {
						let day = new Date(this.date.getFullYear(), this.date.getMonth(), i - before);
						list.push({
							$day: day,
							date: day.format('yyyy-MM-dd'),
							otherMonth: day.getMonth() != this.date.getMonth(),
							today: day.toString() == today.toString(),
							dateList: []
						});
					}
					
					let week = [];
					do {
						week.push(list.splice(0, 7));
					} while (list.length);
					
					this.dayList = week;
					this.monthMoreIndex = -1;
					this.$nextTick(this._resize);
				} else {
					let list = [];
					let before = this.viewType != 'day' ? this.date.getDay() : 0,
						length = this.viewType != 'day' ? 7 : 1;
					for (let i = 0; i < length; i++) {
						let day = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - before + i);
						list.push({
							$day: day,
							date: day.format('yyyy-MM-dd'),
							today: day.toString() == today.toString(),
							dateList: [],
							timeList: []
						});
					}
					
					this.dayList = list;
				}
				this.updateData();
			},
			
			updateData() {
				this.dateQueue = [];
				this.timeQueue = [];
				this.searchParams = this.$refs.search.get();
				this._processFilterData = this.$refs.processFilter ? this.$refs.processFilter.getData() : [];
				this._lastRequest && this._lastRequest.abort();
				this._lastRequest = this.request({
					url: this.dataSource == 1 ? '/work/schedule/list' : '/task/schedule/list',
					data: Object.assign({
						date_type: this.dateType
					}, this.viewType == 'month' ? {
						start_date: this.dayList[0][0].$day.format('yyyy-MM-dd'),
						end_date: this.dayList[this.dayList.length - 1][6].$day.format('yyyy-MM-dd')
					} : {
						start_date: this.dayList[0].$day.format('yyyy-MM-dd'),
						end_date: this.dayList[this.dayList.length - 1].$day.format('yyyy-MM-dd')
					}, this.searchParams),
					success: data => {
						let key = this.dateType == 1 ? 'plan' : 'real';
						for (let day in data) {
							data[day].forEach(item => {
								item[`${key}_end_date`] = item[`${key}_end_date`] || new Date().format('yyyy-MM-dd hh:mm');
								item.schedule_start_date = item[`${key}_start_date`].split(' ')[0];
								item.schedule_start_time = item[`${key}_start_date`].split(' ')[1];
								item.schedule_end_date = item[`${key}_end_date`].split(' ')[0];
								item.schedule_end_time = item[`${key}_end_date`].split(' ')[1];

								item.content = `${item.process_name ? item.process_name + '：' : ''} [${item.plan_count}] ${item.product_name}${item.product_spec ? ` [${item.product_spec}]` : ''} ${item.work_code}`;
								item.state = this.dataSource == 1 ? item.work_state : item.state;
							})
						}
						this.monthMoreIndex = -1;
						if (this.viewType == 'month') {
							this.updateMonthView(data);
						} else {
							this.updateWeekView(data);
						}
					}
				});
			},
			
			setDayData(day, data) {
				day.dateList = [];
				
				if (day.$day.getDay() == 0) {
					let index = 0;
					this.dateQueue = this.dateQueue.filter(item => {
						if (item.after) {
							item.index = index++;
							return true;
						}
					});
				}
				
				this.dateQueue.forEach(item => {
					if (item.after) {
						item.after--;
						day.dateList[item.index] = {
							after: item.after,
							data: item.data
						};
					}
				});
				
				let list = data[day.date];
				if (list) {
					list.forEach(item => {
						if (this.viewType != 'month' && (item.schedule_start_time != '00:00' || (item.schedule_end_time != '00:00' && item.schedule_end_time != '23:59'))) return;

						let temp = {
							start: true,
							data: item
						}
						let index = day.dateList.findIndex(item => !item);
						if (index == -1) {
							index = day.dateList.length;
							day.dateList.push(temp);
						} else {
							day.dateList[index] = temp;
						}
						
						let after = (new Date(item.schedule_end_date).getTime() - new Date(day.date).getTime()) / 86400000 - (item.schedule_end_time == '00:00' ? 1 : 0);
						if (after > 0) {
							this.$set(temp, 'after', after);
							this.dateQueue.push({
								index,
								after,
								data: item
							});
						}
					})
				}
			},
			
			updateMonthView(data) {
				this.dayList.forEach(week => {
					week.forEach(day => {
						this.setDayData(day, data);
					})
				});
			},
			
			updateWeekView(data) {
				function overlapValid(day, target, start, end) {
					let targetData = target.data;
					let targetStartTime = targetData.schedule_start_date == day.date ? targetData.schedule_start_time : '00:00',
						targetEndTime = targetData.schedule_end_date == day.date ? targetData.schedule_end_time : '23:59';
					
					return (
						(start >= targetStartTime && start <= targetEndTime) ||
						(end >= targetStartTime && end <= targetEndTime) ||
						(start < targetStartTime && end > targetEndTime)
					)
				}
				
				this.dayList.forEach(day => {
					this.setDayData(day, data);
					day.timeList = [];
					let list = data[day.date] || [];
					let allList = this.timeQueue.filter(item => item.after > 0).map(item => {
						item.after--;
						return item.data;
					}).concat(list);
					
					allList.forEach(itemData => {
						if (itemData.schedule_start_time == '00:00' && (itemData.schedule_end_time == '00:00' || itemData.schedule_end_time == '23:59')) return;
						
						let startTime = itemData.schedule_start_date == day.date ? itemData.schedule_start_time : '00:00',
							endTime = itemData.schedule_end_date == day.date ? itemData.schedule_end_time : '23:59';
						
						let start = startTime.split(':'),
							end = endTime.split(':');
							
						let item = {
							start: (parseInt(start[0]) * 60 + parseInt(start[1])) / 60,
							end: endTime == '23:59' ? 0 : ((23 - parseInt(end[0])) * 60 + 60 - parseInt(end[1])) / 60,
							after: false,
							data: itemData
						}
						
						let col = 0;
						while (true) {
							if (!day.timeList[col]) {
								this.$set(day.timeList, col, []);
							}
							
							if (!day.timeList[col].length || !day.timeList[col].find(temp => {
								if (overlapValid(day, temp, startTime, endTime)) {
									temp.after = col + 1;
									return true;
								}
								return false;
							})) {
								for (let i = col + 1; day.timeList[i]; i++) {
									if (day.timeList[i].find(temp => {
										if (overlapValid(day, temp, startTime, endTime)) {
											item.after = i;
											return true;
										}
										return false;
									})) {
										break;
									}
								}
								
								day.timeList[col].push(item);
								
								if (list.includes(itemData)) {
									let after = (new Date(itemData.schedule_end_date).getTime() - new Date(day.date).getTime()) / 86400000 - (itemData.schedule_end_time == '00:00' ? 1 : 0);
									if (after > 0) {
										this.timeQueue.push({
											after,
											data: itemData
										});
									}
								}
								
								break;
							}
							
							col++;
						}
					});
				})
			},
			
			beforeRightMenuHandle(data, date, time) {
				if (this._stopPropagation) return;
				this.currentItem = data;
				if (date) {
					this.currentDate = {date, time};
				}
				this._stopPropagation = true;
				setTimeout(() => {
					this._stopPropagation = false;
				}, 10)
			},
			
			rightMenuHandle(item) {
				this.scheduleHandle(item, this.currentItem, this.currentDate);
				this.currentItem = false;
				this.currentDate = false;
			},
			
			moreHandle(i) {
				this.monthMoreIndex = i;
				
				if (i > -1) {
					let num = 0;
					this.dayList[i].forEach(item => {
						num = Math.max(num, item.dateList.length);
					});
					this.monthMoreHeight = num * 29 + 32 + 24;
					if (this.monthMoreHeight <= 115) {
						this.monthMoreIndex = -1;
					}
				}
				
				this.$nextTick(this._resize);
			},

			moreCount(list) {
				return list.map(item => item).splice(this.monthMoreLimit).filter(item => item).length;
			},

			doubleFmt(n) {
				return (n < 10 ? '0' : '') + n;
			},

			filterHandle() {
				this.$refs.search.search();
				setTimeout(() => {
					this.$refs.filter.hide();
				});
			},

			searchProcess(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DICPROCESS',
						keyword: keyword
					},
					success: resolve
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.schedule {
		&-handle {
			box-sizing: border-box;
			height: 80px;
			padding: 10px 16px 0;
			
			.type {
				gap: 6px;
				height: 32px;
				border-radius: 16px;
				padding: 0 6px;
				margin-right: 10px;
				background: #E7F7F4;

				li {
					box-sizing: border-box;
					height: 24px;
					border-radius: 12px;
					padding: 0 8px;
					line-height: 24px;
					font-size: 13px;
					text-align: center;
					cursor: pointer;
					
					&:not(.z-crt):hover {
						color: var(--color-main);
					}

					&.z-crt {
						color: #fff;
						background: var(--color-main);
					}
				}
			}
			
			.tab {
				margin-left: 8px;
				
				li {
					box-sizing: border-box;
					min-width: 32px;
					height: 32px;
					border: 1px solid #ddd;
					padding: 0 10px;
					line-height: 32px;
					font-size: 13px;
					text-align: center;
					cursor: pointer;
					
					&:nth-child(1) {
						border-top-left-radius: 4px;
						border-bottom-left-radius: 4px;
					}
					
					&:nth-child(n+2) {
						margin-left: -1px;
					}
					
					&:nth-last-child(1) {
						border-top-right-radius: 4px;
						border-bottom-right-radius: 4px;
					}
					
					&:hover,
					&.z-crt {
						position: relative;
						border-color: var(--color-main);
						color: #fff;
						background: var(--color-main);
					}
				}
			}

			.legend {
				gap: 10px;
				margin-top: 10px;

				li {
					font-size: 12px;
					color: #666;

					div {
						width: 8px;
						height: 8px;
						border-radius: 50%;
						margin-right: 6px;
					}
				}
			}
		}
		
		&-date {
			font-size: 22px;
		}
		
		&-view {
			overflow: auto;

			.week {
				z-index: 10;
				position: sticky;
				top: 0;
				
				li {
					box-sizing: border-box;
					border: 1px solid #eee;
					border-left: none;
					padding: 0 16px;
					line-height: 36px;
					font-weight: bold;
					background: #FAFAFA;
					
					a {
						width: 24px;
						height: 24px;
						border-radius: 100%;
						margin-left: 8px;
						line-height: 24px;
						font-size: 13px;
						text-align: center;
						
						&:hover,
						&.z-hl {
							color: #fff;
							background: var(--color-main);
						}
					}
				}
				
				&-item {
					min-height: 100px;
				}
			}
			
			.schedule-item {
				gap: 4px;
				white-space: nowrap;

				&:not([blank]) {
					cursor: pointer;

					&[state='1'] {
						background: #F0F0F0;
					}

					&[state='2'] {
						background: #D7E5FB;
					}

					&[state='3'] {
						background: #E0F5EB;
					}

					&[state='4'] {
						background: #FFE6D9;
					}
				}
				
				&.z-hl {
					color: #fff;
					background: var(--color-main) !important;
					
					.icon {
						color: #fff !important;
					}
				}
			}
			
			.schedule-cell {
				&:hover {
					background: #FAFAFA;
				}
			}
			
			.month-day,
			.week-fullday,
			.week-day {
				position: relative;
				box-sizing: border-box;
				border: 1px solid #eee;
				border-top: none;
				overflow: hidden;
				
				&:nth-child(n+2) {
					border-left: none;
				}
			}
			
			.month-week {
				position: relative;
				min-height: 110px;

				&-handle {
					z-index: 2;
					position: absolute;
					left: 0;
					top: 0px;
					right: 0;
					height: 32px;
					cursor: pointer;

					&:hover {
						background: #E7F7F4;
					}
				}
			}
			
			.month-day {
				padding: 32px 0 24px;
				
				.month-week:nth-last-child(1) & {
					border-bottom: none;
				}
				
				&-num {
					z-index: 3;
					position: absolute;
					left: 4px;
					top: 4px;
					width: 24px;
					height: 24px;
					border-radius: 100%;
					line-height: 24px;
					font-size: 13px;
					text-align: center;
					cursor: pointer;
					
					&.z-unimp {
						color: #999;
					}
					
					&:hover,
					&:not(.z-unimp).z-hl {
						color: #fff;
						background: var(--color-main);
					}
				}
				
				&-more {
					position: absolute;
					left: 10px;
					bottom: 6px;
					font-size: 12px;
					color: #999;
					
					&:hover {
						color: var(--color-main);
					}
				}
				
				ul {
					li {
						height: 24px;
						border-radius: 4px;
						padding: 0 6px;
						margin: 0 8px;
						font-size: 12px;
						
						&:nth-child(n+2) {
							margin-top: 5px;
						}
						
						&[across]:not([start]) {
							border-top-left-radius: 0;
							border-bottom-left-radius: 0;
							padding-left: 14px;
							margin-left: 0;
						}
						&[across]:not([end]) {
							border-top-right-radius: 0;
							border-bottom-right-radius: 0;
							padding-right: 14px;
							margin-right: 0;
						}
					}
				}
			}
			
			.week-fullday {
				padding: 0;
				
				&:nth-child(1) {
					width: 50px;
				}
				
				.text {
					box-sizing: border-box;
					padding-right: 6px;
					line-height: 34px;
					font-size: 12px;
					text-align: right;
					color: #666;
				}
				
				.schedule-cell {
					padding: 5px 0;
				}
			}
			
			.week-day {
				z-index: 1;
				position: relative;
				
				&:nth-child(1) {
					width: 50px;
				}
				
				&-col {
					position: absolute;
					inset: 0;
					pointer-events: none;
				}
				
				.hour {
					box-sizing: border-box;
					height: 50px;
					border-top: 1px solid #eee;
					
					&:nth-child(1) {
						border-top: none;
					}
					
					&-text {
						height: 50px;
						padding-right: 6px;
						line-height: 100px;
						font-size: 12px;
						text-align: right;
						color: #666;
						
						&:nth-last-child(1):not(:nth-child(1)) {
							display: none;
						}
					}
				}
				
				ul {
					position: relative;
					height: 100%;
					
					&:nth-child(1) {
						margin-left: 3px;
					}
					&:nth-last-child(1) {
						margin-right: 3px;
					}
					
					li {
						position: absolute;
						left: 0;
						box-sizing: border-box;
						padding: 0 3px;
						
						.schedule-item {
							height: 100%;
							border-radius: 4px;
							padding: 0 6px;
							font-size: 12px;
							pointer-events: auto;
							
							> div {
								gap: 4px;
								height: 100%;
								max-height: 25px;
							}
						}
					}
				}
			}
		}
	}

	.filter {
		position: relative;
		width: 30px;
		height: 30px;
		font-size: 18px;
		cursor: pointer;

		&:hover {
			color: var(--color-main);
		}

		span {
			position: absolute;
			right: -2px;
			top: -2px;
			width: 15px;
			height: 15px;
			border-radius: 50%;
			font-size: 12px;
			text-align: center;
			color: #fff;
			background: #FFA82B;
		}

		&-search {
			padding: 10px 5px;
		}

		&-button {
			height: 32px !important;
			margin-top: 12px;

			&:nth-child(2) {
				width: 30%;
				margin-left: 10px;
			}
		}
	}

	.refresh {
		width: 30px;
		height: 30px;
		font-size: 18px;

		&:hover {
			color: var(--color-main) !important;
		}
	}
</style>